<template>
  <div class="ibox">
      <div class="ib-sub-content">
          <!-- ユーザー検索ボックス-チェックボックス型 -->
        <div class="tabs-container">
            <div class="ibox-title search-box">
              <div class="row">
                  <div class="col-sm-12">
                      <div class="input-group">
                          <input type="text" v-model="searchText" class="typeahead_2 form-control" :placeholder="$t('searchWithUserName')">
                      </div>
                  </div>
              </div>
            </div>
            <div class="ib-sub-content">
                <b-tabs>
                  <b-tab :title="$t('userBtnTile')" class="tab-pane search-resultview">
                    <ul v-if="searchText == ''">
                      <li><label>{{$t('checkUserStrType')}}</label></li>
                      <li v-if="getVisitedUsers.length === 0" class="result-item"><label>{{$t('notFoundUserStr')}}</label></li>
                      <li v-for="user in getVisitedUsers" :key="user.id" v-if="user && user.userInfo && user.userId !== uid" class="result-item"><label>
                        <input type="checkbox" v-model="checkUsers" v-bind:value="user.userId" class="checkbox public-check">
                        <span class="search-userimg">
                          <img v-if="user.userInfo.userIcon" :src="user.userInfo.userIcon" alt="image" class="img-circle">
                          <img v-else :src="'static/img/noImage.png'" alt="image" class="img-circle">
                        </span>
                        <div class="search-userinfo">
                          <span class="search-username">{{ user.userInfo.userName }}</span>
                          <span class="search-userdept">{{ user.userInfo.dept }}</span>
                        </div>
                        <span class="check-mark"></span>
                      </label></li>
                    </ul>
                    <ul v-else>
                      <li v-if="Object.keys(this.getUsersBySearchText).length === 0" class="result-item"><label>{{$t('notFoundUserStr')}}</label></li>
                      <li v-for="(user, key) in getUsersBySearchText" :key="user.id" v-if="user && user.userInfo && key !== uid" class="result-item"><label>
                        <input type="checkbox" v-model="checkUsers" v-bind:value="key" class="checkbox public-check">
                        <span class="search-userimg">
                          <img v-if="user.userInfo.userIcon" :src="user.userInfo.userIcon" alt="image" class="img-circle">
                          <img v-else :src="'static/img/noImage.png'" alt="image" class="img-circle">
                        </span>
                        <div class="search-userinfo">
                          <span class="search-username">{{ user.userInfo.userName }}</span>
                          <span class="search-userdept">{{ user.userInfo.dept }}</span>
                        </div>
                        <span class="check-mark"></span>
                      </label></li>
                    </ul>
                  </b-tab>
              </b-tabs>
          </div>
        </div>
        <!-- /ユーザー検索ボックス-チェックボックス型 -->
    </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'PublicSettingDetailView',
  props: {
    checkedUsers: {},
    uid: ''
  },
  data: function () {
    return {
      searchText: '',
      checkUsers: this.checkedUsers
    }
  },
  watch: {
    checkUsers: function () {
      this.$emit('updateUsers', this.checkUsers)
    }
  },
  computed: {
    ...mapGetters([
      'getCurrentUser'
    ]),
    ...mapGetters('users/', [
      'getUsersByIds',
      'getUsersByText'
    ]),
    ...mapGetters('_meta/', [
      'getMetaIsDeleted'
    ]),
    getVisitedUsers: function () {
      const currentUser = this.getCurrentUser
      console.log('currentUser', currentUser)
      if (currentUser && currentUser.hasOwnProperty('visitHistory')) {
        console.log('in if getVisit')
        // return this.getUsersByIds(Object.keys(currentUser.visitHistory))
        const visitHistory = Object.keys(currentUser.visitHistory || [])
        const recentlyCheckedUsers = this.getUsersByIds(Object.keys(currentUser.visitHistory))
        let sortedRecentlyCheckedUsers = visitHistory.sort((a, b) => { return currentUser.visitHistory[b] - currentUser.visitHistory[a] })
          .filter(key => !this.getMetaIsDeleted(key))
          .map(x => { return recentlyCheckedUsers[x] })
        console.log(sortedRecentlyCheckedUsers)
        return sortedRecentlyCheckedUsers
      } else {
        console.log('in else getVisit')
        return {}
      }
    },
    getUsersBySearchText: function () {
      if (this.searchText.length === 0) {
        this.usersForRelation = this.getUsers
        return this.getUsers
      } else {
        this.usersForRelation = this.getUsersByText(this.searchText)
        return this.getUsersByText(this.searchText)
      }
    }
  },
  methods: {
    resetCheckings () {
      this.checkUsers = []
    }
  },
  filters: {
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/DetailView/ShareSettingDetailView.vue